import { render, staticRenderFns } from "./UserEditProfile.vue?vue&type=template&id=0a63994a&scoped=true"
import script from "./UserEditProfile.vue?vue&type=script&lang=js"
export * from "./UserEditProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a63994a",
  null
  
)

export default component.exports